export const SCREENS = {
  TITLE: 'Title',
  LEVEL: 'Level',
  LOSE: 'Lose',
  WIN: 'Win',
  ABILITY_SELECT: 'AbilitySelect',
  LEVEL_PROGRESS: 'LevelProgress',
  INTRO_MOVIE: 'IntroMovie',
}